'use client';

import { imageGallerySection } from '@stereoagency/sanity-schema';
import { ImageGallerySection as UIImageGallerySection } from '@stereoagency/ui';
import flush from 'just-flush';
import { sanityImageAsProps } from '@/utils';

type Props = typeof imageGallerySection.schema.imageGallerySection;

export default function ImageGallerySection({ images, accentColor }: Props) {
  if (!images?.length) {
    return null;
  }

  return (
    <UIImageGallerySection
      images={flush(
        images.map((image) => {
          if (!image.asset._ref) {
            return null;
          }

          return sanityImageAsProps(image);
        })
      )}
      accentColor={accentColor?.hex}
    />
  );
}
